import { Alert, Dialog } from '@mui/material'
import { useState } from 'react'
import { DropPaper } from '../DropPaper'
import MainButton from '../../common/util/input/MainButton'
import InputField from '../../common/util/InputField'

export const AddAttributeDialog = ({
    attributes,
    setAttributes,
    addAttributeDialogOpened,
    setAddAttributeDialogOpened,
}) => {
    const [attributeName, setAttributeName] = useState('')

    const addAttribute = () => {
        const temp = [...attributes]

        let newLayer = 0

        if (temp.length > 0) {
            // we need to make sure the new attribute is added to the very front.
            // For that we need to find the current max layer, which could be hidden within any trait
            for (const attr of temp) {
                for (const attrValue of attr.possible_values) {
                    for (const layer of attrValue.layers) {
                        if (layer.layer > newLayer) {
                            newLayer = layer.layer
                        }
                    }
                }
            }

            newLayer++
        }

        temp.push({
            attribute_name: attributeName,
            possible_values: [
                {
                    value: 'none',
                    chance: 0,
                    guaranteed: false,
                    layers: [{ ipfs: '', layer: parseInt(newLayer) }],
                },
            ],
        })
        setAttributes(temp)
    }

    const closeDialog = () => {
        setAttributeName('')
        setAddAttributeDialogOpened(false)
    }

    return (
        <Dialog
            open={addAttributeDialogOpened}
            onClose={() => {
                closeDialog()
            }}
            fullWidth
            maxWidth="md"
        >
            <DropPaper noMargin>
                <div className="text-2xl text-center">Add New Attribute</div>
                <div className="flex flex-wrap justify-center my-5">
                    <InputField
                        className="w-60"
                        label="Attribute Name"
                        value={attributeName}
                        isRequired={true}
                        isInvalid={attributeName.length === 0}
                        onChange={(e) => {
                            setAttributeName(e.target.value)
                        }}
                    />
                </div>
                <Alert severity="info">
                    By default, we will initialise the new attribute with a
                    special <span className="font-mono">none</span> value with a
                    chance of 0. It represents an empty layer. You can edit it
                    or alter its chance (if keeping the layer empty should be a
                    possible outcome in your drop) from the overview.
                </Alert>
                <div className="flex flex-wrap justify-center my-10">
                    <div className="w-48 mx-2">
                        <MainButton
                            fullWidth
                            size="small"
                            isDisabled={!attributeName}
                            onClick={() => {
                                addAttribute()
                                closeDialog()
                            }}
                        >
                            {' '}
                            Add Attribute
                        </MainButton>
                    </div>
                    <div className="w-48 mx-2 my-2 md:my-0">
                        <MainButton
                            fullWidth
                            color="danger"
                            onClick={() => {
                                closeDialog()
                            }}
                        >
                            {' '}
                            Cancel
                        </MainButton>
                    </div>
                </div>
            </DropPaper>
        </Dialog>
    )
}
